module.exports = __webpack_public_path__ + "img/V9-bg.c76e785b.png";